import { createFileRoute } from '@tanstack/react-router';
import { SupportTicketDetailError } from '@/pages/support-tickets/detail-error';
import { SupportTicketDetailSheet } from '@/pages/support-tickets/detail-sheet';
import { TICKET_DETAIL_SEARCH_KEYS } from '@/pages/support-tickets/lib/ticket-detail-tabs';
import { TICKET_ROUTES } from '@/pages/support-tickets/lib/ticket-routes';
import {
  buildListNavigation,
  withoutSearchKeys,
} from '@/lib/helpers/list-routes';

/**
 * Rotta del dettaglio: ci si arriva dal click di riga e dal link nell'email
 * di alert operatori. Renderizza SOLO la sheet — la coda sta gia' sotto,
 * montata dal layout — cosi' chiudendola si torna alla lista esattamente
 * dov'era, senza la scheda del dettaglio (`?tab=`).
 */
function SupportTicketDetailRoute() {
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();

  return (
    <SupportTicketDetailSheet
      ticketId={id}
      onClose={() =>
        navigate(
          buildListNavigation(
            TICKET_ROUTES.list,
            withoutSearchKeys(TICKET_DETAIL_SEARCH_KEYS)
          )
        )
      }
    />
  );
}

export const Route = createFileRoute('/admin/_layout/tickets/_layout/$id')({
  component: SupportTicketDetailRoute,
  errorComponent: SupportTicketDetailError,
});
